<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';

const props = defineProps({
  lead: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['message', 'call', 'profile']);

const handleContactAction = action => {
  if (action === 'message') {
    emit('message');
    return;
  }

  if (action === 'call') {
    emit('call');
    return;
  }

  emit('profile');
};

const contactPhone = computed(
  () => props.lead?.phone_number || props.lead?.phoneNumber || ''
);
const hasContactPhone = computed(() => /\d/.test(contactPhone.value));

const contacts = computed(() => [
  {
    key: 'client',
    title: 'Cliente',
    value:
      props.lead?.name ||
      contactPhone.value ||
      props.lead?.email ||
      'Cliente não informado',
    icon: 'i-lucide-user-round',
    action: 'profile',
    label: 'Copiar link do histórico',
    ariaLabel: 'Copiar link do histórico do cliente',
    disabled: false,
  },
  {
    key: 'phone',
    title: 'Telefone',
    value: contactPhone.value || 'Telefone não informado',
    icon: 'i-lucide-phone',
    action: 'call',
    label: 'Ligar para cliente',
    ariaLabel: 'Ligar para cliente',
    disabled: !hasContactPhone.value,
  },
  {
    key: 'message',
    title: 'Mensagem',
    value: contactPhone.value || 'Telefone não informado',
    icon: 'i-lucide-message-circle',
    action: 'message',
    label: 'Enviar mensagem',
    ariaLabel: 'Enviar mensagem para cliente',
    disabled: !hasContactPhone.value,
  },
]);
</script>

<template>
  <div class="grid grid-cols-1 gap-3 md:grid-cols-3">
    <article
      v-for="contact in contacts"
      :key="contact.key"
      class="min-w-0 rounded-lais-sm border border-lais-border bg-white p-3"
    >
      <div class="flex items-start gap-3">
        <span
          class="grid size-9 place-items-center rounded-full bg-lais-primary-50 text-lais-primary"
        >
          <span class="size-4" :class="contact.icon" aria-hidden="true" />
        </span>
        <div class="min-w-0 flex-1">
          <p class="text-[12px] font-semibold uppercase text-lais-text-muted">
            {{ contact.title }}
          </p>
          <p
            class="mt-1 break-words text-[13px] font-semibold text-lais-text [overflow-wrap:anywhere]"
          >
            {{ contact.value }}
          </p>
        </div>
      </div>
      <button
        type="button"
        class="mt-3 inline-flex min-h-9 w-full items-center justify-center rounded-full border border-lais-border px-3 text-center text-[12px] font-semibold text-lais-primary transition-colors hover:border-lais-primary hover:bg-lais-primary-50/40 focus-visible:outline-none focus-visible:shadow-lais-focus disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
        :aria-label="contact.ariaLabel"
        :disabled="contact.disabled"
        :title="
          contact.disabled
            ? 'Telefone não informado para este cliente.'
            : undefined
        "
        @click="handleContactAction(contact.action)"
      >
        {{ contact.label }}
      </button>
    </article>
  </div>
</template>
